/**
 * 综合能源管理模块
 */
import request from "@/utils/request.js";

// 获取数据
export const getDataAcquisition = (params) => {
  return request({
    url: "/energy/user",
    methods: "GET",
    params,
  });
};

// 数据采集-获取表格数据
export const getDataAcquisitionNew = (params) => {
  return request({
    url: "/energy/user",
    methods: "GET",
    params,
  });
};

// 数据采集
export const postUpData = (data) => {
  return request({
    url: "/energy/data",
    method: "post",
    data,
  });
};

// 上传文件
export const postUploadFile = (data) => {
  return request({
    url: "/contract/upload",
    // url: "/upload",
    method: "post",
    timeout: 10000,
    headers: {
      // "Content-Type": "multipart/mixed",
      "Content-Type": "multipart/form-data",
    },
    data,
  });
};

// 获取电价
export const getElectPrice = () => {
  return request({
    url: "/energy/priceGet",
    methods: "GET",
  });
};

// 修改电价
export const postElectPrice = (data) => {
  return request({
    url: "/energy/price",
    method: "post",
    data,
  });
};

// 获取历史合同
export const getHistoryFile = (params) => {
  return request({
    // url: "/energy/contract",
    url: "/contract/history",
    methods: "GET",
    params,
  });
};

// 查看单个历史合同
export const checkContract = (params) => {
  return request({
    // url: "/energy/contract",
    url: "/oss/check",
    methods: "GET",
    params: {
      id: params,
    },
  });
};

// 获取业扩报装列表
export const getBusinessApi = () => {
  return request({
    url: "/buse/list",
    methods: "GET",
  });
};
// 修改状态
export const changeStatusApi = (params) => {
  return request({
    url: `/buse/busStatusUp?id=${params.id}&status=${params.status}`,
    methods: "GET",
  });
};

// 生成支付二维码
export const generatePaymentCodeApi = () => {
  return request({
    url: "/AlipayFaceToFaceController/ZFBPreorderAction",
    methods: "GET",
  });
};

// 终端用户查询接口;
export const getUserListA = (params) => {
  return request({
    url: "/buse/apply",
    methods: "post",
    params,
  });
};
// 终端用户综合管理业务申报接口;
export const businessApi = (data) => {
  return request({
    url: "/declare/apply",
    method: "post",
    data,
  });
};
// 终端用户业扩报装报装申请接口;
export const businessApplyApi = (data) => {
  return request({
    url: "/buse/apply",
    method: "post",
    data,
  });
};
// 终端用户业扩报装报装历史接口;
export const installationHistoryApi = () => {
  return request({
    url: "/buse/list",
    method: "get",
  });
};
